import { lazy } from "react";

export const AuthLogin = lazy(() => import("../components/AuthLogin"));

export const Dashboard = lazy(() => import("../components/Dashboard"));

export const Admin = lazy(() => import("../components/Admin"));

export const Profile = lazy(() => import("../components/Profile"));

export const SignIn = lazy(() => import("../components/SignIn"));

export const TableData = lazy(() =>
  import("../components/TableData").then((m) => ({
    default: m.TableData,
  })),
);

export const OrderInfoDialog = lazy(() =>
  import("../components/misc/OrderInfoDialog"),
);

export const AddCarrier = lazy(() => import("../pages/AddCarrier"));

export const DeleteRecord = lazy(() => import("../pages/DeleteRecord"));

export const BerlinQuestionaire = lazy(() =>
  import("../pages/forms/BerlinQuestionaire"),
);

export const EpworthSleepinessScale = lazy(() =>
  import("../pages/forms/EpworthSleepinessScale"),
);

export const QualityImprovementSurvey = lazy(() =>
  import("../pages/forms/QualityImprovementSurvey"),
);

export const SatisfactionSurvey = lazy(() =>
  import("../pages/forms/SatisfactionSurvey"),
);

export const StopBangQuestionaire = lazy(() =>
  import("../pages/forms/StopBangQuestionaire"),
);

export const GroupView = lazy(() => import("../pages/GroupView"));

export const InsuranceView = lazy(() => import("../pages/InsuranceView"));

export const InterpPhysView = lazy(() => import("../pages/InterpPhysView"));

export const LocationView = lazy(() => import("../pages/LocationView"));

export const NotFoundPage = lazy(() =>
  import("../pages/pageNotFound/NotFoundPage"),
);

export const ContactUs = lazy(() =>
  import("../pages/patientPortal/contactUs/ContactUs"),
);

export const PatientPortalHomePage = lazy(() =>
  import("../pages/patientPortal/patientPortalHomePage/PatientPortalHomePage"),
);

export const PatientPortalPastVisits = lazy(() =>
  import(
    "../pages/patientPortal/patientPortalPastVisits/PatientPortalPastVisits"
  ),
);

export const PatientPortalProfilePage = lazy(() =>
  import(
    "../pages/patientPortal/patientPortalProfile/PatientPortalProfilePage"
  ),
);

export const Scheduling = lazy(() =>
  import("../pages/patientPortal/Scheduling/Scheduling"),
);

export const ForgotPassword = lazy(() =>
  import("../pages/patientPortal/signInLanding/ForgotPassword"),
);

export const MFASetup = lazy(() =>
  import("../pages/patientPortal/signInLanding/MFASetup"),
);

export const SignInInitial = lazy(() =>
  import("../pages/patientPortal/signInLanding/SignInInitial"),
);

export const SignInLanding = lazy(() =>
  import("../pages/patientPortal/signInLanding/SignInLanding"),
);

export const SignInPatient = lazy(() =>
  import("../pages/patientPortal/signInLanding/SignInPatient"),
);

export const CreditCardPayment = lazy(() =>
  import("../pages/patients/components/CreditCardPayment/CreditCardPayment"),
);

export const MakePayment = lazy(() =>
  import("../pages/patients/components/CreditCardPayment/MakePayment"),
);

export const NewOrder = lazy(() =>
  import("../pages/patients/components/newOrder/NewOrder"),
);

export const NewSurvey = lazy(() =>
  import("../pages/patients/components/NewSurvey"),
);

export const OrderView = lazy(() =>
  import("../pages/patients/components/OrderView"),
);

export const PatientView = lazy(() =>
  import("../pages/patients/components/PatientView"),
);

export const SurveyView = lazy(() =>
  import("../pages/patients/components/SurveyView"),
);

export const DmeOrder = lazy(() =>
  import("../pages/patients/dmeOrder/DmeOrder"),
);

export const Patients = lazy(() => import("../pages/patients/Patients"));

export const PhysicianProfile = lazy(() => import("../pages/PhysicianProfile"));

export const ReferralView = lazy(() => import("../pages/ReferralView"));

export const Reports = lazy(() => import("../pages/reports/Reports"));

export const RoleView = lazy(() => import("../pages/RoleView"));

export const UserView = lazy(() => import("../pages/UserView"));
